import { render, staticRenderFns } from "./metodosXFormaEdit.vue?vue&type=template&id=2a8dc4e9"
import script from "./metodosXFormaEdit.ts?vue&type=script&lang=js&external"
export * from "./metodosXFormaEdit.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a8dc4e9')) {
      api.createRecord('2a8dc4e9', component.options)
    } else {
      api.reload('2a8dc4e9', component.options)
    }
    module.hot.accept("./metodosXFormaEdit.vue?vue&type=template&id=2a8dc4e9", function () {
      api.rerender('2a8dc4e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/formarecebimento/metodosXFormaEdit.vue"
export default component.exports